/* Care Guides hub (sections/care-guides-hub-ggd.liquid).
   Filters the guide cards on the page as the visitor types, so the search
   only ever covers care guides. No match shows the request prompt, which
   prefills the request form with the search text. Theme-agnostic: loaded
   by both Horizon and the legacy Quantum theme. */
(function () {
  function init(hub) {
    var input = hub.querySelector('[data-care-search-input]');
    var form = hub.querySelector('[data-care-search]');
    var status = hub.querySelector('[data-care-status]');
    var empty = hub.querySelector('[data-care-empty]');
    var emptyLink = hub.querySelector('[data-care-empty-request]');
    var plant = hub.querySelector('[data-care-request-plant]');
    var cards = Array.prototype.slice.call(hub.querySelectorAll('[data-care-card]'));
    var groups = Array.prototype.slice.call(hub.querySelectorAll('[data-care-group]'));
    var jumps = Array.prototype.slice.call(hub.querySelectorAll('[data-care-jump]'));
    if (!input) return;

    function normalize(value) {
      return value.toLowerCase().replace(/[^a-z0-9 ]+/g, ' ').replace(/\s+/g, ' ').trim();
    }

    var haystacks = cards.map(function (card) {
      return normalize(card.getAttribute('data-search') || '');
    });

    function message(count) {
      if (count === 0) return hub.getAttribute('data-count-none') || '';
      if (count === 1) return hub.getAttribute('data-count-one') || '';
      return (hub.getAttribute('data-count-many') || '').replace('[count]', count);
    }

    var timer;
    function apply() {
      var query = normalize(input.value);
      var words = query ? query.split(' ') : [];
      var shown = 0;

      cards.forEach(function (card, i) {
        var match = words.every(function (word) {
          return haystacks[i].indexOf(word) !== -1;
        });
        card.hidden = !match;
        if (match) shown += 1;
      });

      groups.forEach(function (group) {
        var visible = group.querySelector('[data-care-card]:not([hidden])');
        group.hidden = !visible;
        var jump = jumps.filter(function (link) {
          return link.getAttribute('data-care-jump') === group.getAttribute('data-care-group');
        })[0];
        if (jump) jump.parentNode.hidden = !visible;
      });

      if (empty) empty.hidden = !(words.length && shown === 0);
      if (status) {
        clearTimeout(timer);
        timer = setTimeout(function () {
          status.textContent = words.length ? message(shown) : '';
        }, 400);
      }
    }

    input.addEventListener('input', apply);
    if (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        apply();
      });
    }

    if (emptyLink && plant) {
      emptyLink.addEventListener('click', function () {
        if (!plant.value) plant.value = input.value.trim();
        setTimeout(function () {
          plant.focus();
        }, 0);
      });
    }

    var done = hub.querySelector('[data-care-request-done]');
    if (done) {
      done.scrollIntoView({ block: 'center' });
      done.focus({ preventScroll: true });
    }
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-care-hub]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
